import { epoch, utc } from '../../util/datetime';
import { toUUID } from '../../util/transform';
import type { IExportAccessHistory } from './ExportAccessHistory.interface';

export default class ExportAccessHistory implements IExportAccessHistory {
  idAccount: string;
  accountInformation: string;
  ipAddress: string;
  timeStamp: number;
  action: string;

  static build = (data: IExportAccessHistory) => new ExportAccessHistory(data);
  static blank = () => new ExportAccessHistory();

  /**
   * Constructor
   * @param {IExportAccessHistory} data
   */
  constructor(data?: IExportAccessHistory) {
    this.idAccount = toUUID(data?.idAccount);
    this.accountInformation = data?.accountInformation || '';
    this.ipAddress = data?.ipAddress || '';
    this.timeStamp = epoch(utc(data?.timeStamp));
    this.action = data?.action;
  }
}
